import { graphql, Link } from 'gatsby';
import React from 'react';
import { Column, Container, Row } from '../components/Grid';
import Image from '../components/Image';
import Layout from '../components/Layout';
import Section from '../components/Section';

const AlumniGrantRecipient = ({ data: { recipient }, pageContext: { relatedRecipients } }) => {
  return (
    <Layout
      title={`Alumni Grant Recipient: ${recipient.firstName} ${recipient.lastName}`}
      className="alumni-center bios"
    >
      {/* Alumni Profile */}
      <Section className="alumni">
        <Container>
          {/* Breadcrumbs */}
          <ul className="breadcrumbs no-hero">
            <li className="breadcrumb">
              <Link to="/alumni-center/overview">Overview</Link>
            </li>
            <li className="breadcrumb">
              <Link to="/alumni-center/alumni-grant-recipients">
                Alumni Grant Recipients
              </Link>
            </li>
            <li className="breadcrumb active">
              {recipient.firstName} {recipient.lastName}
            </li>
          </ul>
          <Row>
            <Column size={7} offset={1} className="alumni__profile-left pr-2">
              <h2 className="alumni__profile-greeting">Meet Alumni:</h2>
              <h1 className="alumni__profile-title">
                {recipient.firstName} {recipient.lastName}
              </h1>
              <h3 className="alumni__profile-type">
                {recipient.finalistYear} 3M Young Scientist Challenge{' '}
                {recipient.finalistAward}
                <br />
                {recipient.year} Alumni Grant Recipient
              </h3>
              <h4 className="alumni__profile-project">
                {recipient.cardDescription}
              </h4>
              <h2 className="alumni__profile-question">About their Project</h2>
              {recipient.aboutProject.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
              <h2 className="alumni__profile-question">
                What was the inspiration behind your project?
              </h2>
              {recipient.inspiration.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </Column>
            <Column size={4}>
              <div className="global__profile-box box-shadow">
                <div className="global__profile-image">
                  <Image filename={recipient.quoteImage || recipient.cardImage} />
                </div>
                <div className="global__profile-content">
                  <h4 className="quote">{recipient.quote}</h4>
                  <h3>
                    {recipient.firstName} {recipient.lastName}
                  </h3>
                  <p>
                    {recipient.finalistYear} {recipient.finalistAward}
                  </p>
                </div>
              </div>
            </Column>
          </Row>
        </Container>
      </Section>

      {/* Related Alumni Profiles */}
      {relatedRecipients && relatedRecipients.length > 0 && (
        <Section className="related-profiles">
          <Container>
            <Row>
              <Column fullwidth>
                <h2>Related Alumni</h2>
              </Column>
            </Row>
            <Row>
              {relatedRecipients.map((related, i) => (
                <Column size={4} key={i}>
                  <div className="profile-card box-shadow hover imagezoom">
                    <div className="profile-card__image">
                      <Image filename={related.cardImage} />
                    </div>
                    <div className="profile-card__content">
                      <span>{related.finalistYear} {related.finalistAward}</span>
                      <br />
                      <span>{related.year} Alumni Grant Recipient</span>
                      <h3>
                        {related.firstName} {related.lastName}
                      </h3>
                      <p>
                        Meet {related.firstName}. {related.cardDescription}
                      </p>
                      <Link
                        to={`/alumni-center/alumni-grant-recipients/${related.slug}`}
                        className="text-20 text-bold"
                      >
                        Learn More {'>'}
                      </Link>
                    </div>
                  </div>
                </Column>
              ))}
            </Row>
          </Container>
        </Section>
      )}
    </Layout>
  );
};

export const query = graphql`
  query ($slug: String!) {
    recipient: alumniGrantRecipientsYaml(slug: { eq: $slug }) {
      firstName
      lastName
      slug
      year
      finalistYear
      finalistAward
      grantType
      cardImage
      quoteImage
      quote
      cardDescription
      aboutProject
      inspiration
    }
  }
`;

export default AlumniGrantRecipient;
